"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "reana-del-rojale": {
    "bfd34d8f": [{
      "hkey": "899e671f",
      "slug": "ribis-rizzolo",
      "name": "Ribis-Rizzolo",
      "primary": true,
      "skipSearch": false
    }],
    "ribis": [{
      "hkey": "899e671f",
      "slug": "ribis-rizzolo",
      "name": "Ribis-Rizzolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a2bbd8b": [{
      "hkey": "899e671f",
      "slug": "ribis-rizzolo",
      "name": "Ribis-Rizzolo",
      "primary": true,
      "skipSearch": false
    }],
    "rizzolo": [{
      "hkey": "899e671f",
      "slug": "ribis-rizzolo",
      "name": "Ribis-Rizzolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reana-del-rojale"
    }],
    "658686b0": [{
      "hkey": "86664214",
      "slug": "valle-vergnacco",
      "name": "Valle-Vergnacco",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "86664214",
      "slug": "valle-vergnacco",
      "name": "Valle-Vergnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1cefa2ae": [{
      "hkey": "86664214",
      "slug": "valle-vergnacco",
      "name": "Valle-Vergnacco",
      "primary": true,
      "skipSearch": false
    }],
    "vergnacco": [{
      "hkey": "86664214",
      "slug": "valle-vergnacco",
      "name": "Valle-Vergnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reana-del-rojale"
    }]
  }
};
exports["default"] = _default;